<template>
  <container>
    <race-header title="Update Race"></race-header>

    <custom-form  v-if="update">
    <text-field v-model="update.name" label="Name" name="name" v-validate="'required'" data-vv-value-path="input" data-vv-name="name" error-message="Fill in the name" :has-error=" errors.has('name')" :required="true"></text-field>

    <div class="form__group">
      <label for="description">Description <span class="required">*</span></label>
      <textarea v-validate data-vv-rules="required" :class="{'form-control': true, 'is-danger': errors.has('description') }" name="description" rows ="6" v-model="update.description" id="txtArea" @keypress="onDescriptionChange" required></textarea>
    </div>

    <date-time-field v-model="update.date" :label="`Date - ${getTimezone()}`" name="date" v-validate="'required'" data-vv-value-path="startDate.time" data-vv-name="date" error-message="Fill in the date" :has-error=" errors.has('date')" :required="true"></date-time-field>

    <div class="form__group">
      <label for="duration">Duration(in minutes):</label>
      <input v-validate="'required'" :class="{'form-control': true,  'is-danger': errors.has('duration') }" type="number" step="1" :min="1" :max="max_duration" name="duration" v-model.number="update.duration" required>
      <span v-show="errors.has('duration')" class="help is-danger">Fill in the duration</span>
    </div>


    <div class="form__group">
      <div style="display: inline-flex;" >
        <div style="margin-right: 100px;">
          <label for="type">First Type:</label>
          <select v-model="update.type" label="First Type" name="type" style="height: 33px;">
            <option value="LIVE"> Live (Medal) </option>
            <option value= "NO_MEDAL"> No Medal </option>
            <option value= "ON_DEMAND_MEDAL"> On demand (Medal)</option>
            <option value= "ON_DEMAND_NO_MEDAL"> On demand (No Medal) </option>
          </select>
        </div>
        <div v-if="update.type == 'ON_DEMAND_MEDAL' || update.type == 'ON_DEMAND_NO_MEDAL'" style="margin-right: 100px;">
          <race-media  @saved="loadAudio"  v-model="update.audioFileUrl" label="On demand File" name="media"  data-vv-value-path="input" data-vv-name="media" error-message="Fill in the audio" :has-error=" errors.has('media')" :required="false"></race-media>
        </div>
         <div v-if="(update.type == 'ON_DEMAND_MEDAL' || update.type == 'ON_DEMAND_NO_MEDAL' ) &&
         update.audioFileUrl" >
          <label for="type">Current On demand File: </label>
          <audio id="ondemand-audio" controls style="height:35px">
            <source :src="update.audioFileUrl" type="audio/mp3">
          </audio>
        </div>
      </div>
    </div>
    <div class="form__group">
      <label for="type">Second Type:</label>
      <select v-model="update.secondType" label="Type" name="type" >
       <option v-for="type in raceTypes" v-bind:value="type.name">{{type.englishText}}</option>
      </select>
    </div>

    <div class="form__group">
      <label for="type">Third Type:</label>
        <select v-model="update.thirdType" label="Type" name="type" >
          <option value=''> NONE </option>
          <option value='NO_MEDAL'> NO MEDAL </option>
          <option value="PromoL"> L </option>
          <option value="PromoI"> I </option>
          <option value="PromoV"> V </option>
          <option value="PromoE"> E </option>
          <option value="LIVE_60MIN"> 60MIN_MEDAL </option>
          <option value="PromoU"> U </option>
          <option value="PromoR"> R </option>
          <option value="MEDAL_20K"> 20Km Medal </option>
        </select>
    </div>

    <div class="form__group">
      <label for="type">Channel:</label>
      <select v-model="update.mobileChannelToPlay" label="Channel" name="channel" style="width: 9%;" >
        <option :value= channels.audioChannelA > A </option>
        <option :value= channels.audioChannelB> B </option>
        <option :value= channels.audioChannelC> C </option>
        <option :value= channels.audioChannelD> D </option>
      </select>
    </div>

    <div class="form__group">
      <label for="type">Language:</label>
      <select v-model="update.language" label="Language" name="language" >
        <option v-for="locale in locales" v-bind:value="locale.id">{{locale.name}}</option>
      </select>
    </div>


    <div class="form__group" style="display: inline-flex;">
        <div class="actionImgContent">
        <div class="form__group" style="margin-top: 20px;">
          <label for="type">RSVP Limit:</label>
          <input v-validate="'required'" :class="{'form-control': true,  'is-danger': errors.has('rsvp_limit') }" type="number" step="1" :min="1" :max="max_rsvp_limit" name="rsvp_limit" v-model.number="update.rsvp_limit" required>
          <span v-show="errors.has('rsvp_limit')" class="help is-danger">Fill in the RSVP limit</span>
        </div>
        </div>

        <div style="width: 35rem" >
          <div v-if="update.actionImageUrl != ''" style="display: inline-flex;">
            <div>
              <p>Current Action Image:</p>
              <img :src="update.actionImageUrl" width="100px" height="100px" style="border-radius: 50%;border:2px solid black;">
            </div>
            <div style="margin-top:auto">
              <img style="cursor:pointer"  @click="removeActionImg()" src="../../assets/delete2.png"/>
            </div>
          </div>
        </div>
    </div>

    <div class="form__group"  style="display: inline-flex;">
      <div class="actionImgContent">
        <div class="form__group" style="margin-bottom: 15px;">
          <label for="type">Action URL:</label>
          <text-field v-model="update.endSessionUrl"  name="endSessionUrl"  data-vv-value-path="input" data-vv-name="name" ></text-field>
        </div>
      </div>
      <div style="width: 35rem" >
        <race-photo v-model="update.actionImageUrl" label="Action Image" name="actionImage"
          data-vv-value-path="input" data-vv-name="actionImage"
          error-message="Fill in the photo with size below 200 Kb"
        :has-error=" errors.has('actionImage')" :required="false"></race-photo>
      </div>
    </div>



    <div class="form__group race-tags" >
        <label for="type"> Tags:</label>
        <selectize v-bind:options="tagsOptions" v-model="selectedTags"
          multiple size="1"
          :isRunnerTag=false
          :isRaceTag=true
          :raceId="this.$route.params.raceId"
          data-dropdown-parent="body" data-max-options="100"
          data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
          style="visibility:hidden">
        </selectize>
    </div>



    <div>
      <div v-if="update.imageUrl != ''">
        <p>Current photo race:</p>
        <img :src="update.imageUrl" width="200px">
      </div>
        <upload-photo v-model="update.imageUrl" label="Photo" name="photo" v-validate="'required'" data-vv-value-path="input" data-vv-name="photo" error-message="Fill in the photo with size below 200 Kb" :has-error=" errors.has('photo')" :required="true"></upload-photo>

    </div>

      <div class="form__group">
        <label for="type"> Trainer:</label>
          <select v-model="trainerId" label="Trainer" name="Trainer"  @change="changeTrainer" class="trainer-list">
            <option v-for="(trainer, index) in trainerList" v-bind:value="trainer.id" :key="index">{{trainer.firstName}}</option>
          </select>
      </div>



    <button class="btn btn--primary" id="submit-form" @click="handleSubmit()">Update Race</button>
    </custom-form>
  </container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Container from '@/components/Container'
import RaceHeader from '@/components/Race/Header'
import CustomForm from '@/components/Forms/Form'
import TextField from '@/components/Forms/TextField'
import IntegerField from '@/components/Forms/IntegerField'
import DateTimeField from '@/components/Forms/DateTimeField'
import RacePhoto from '@/components/Forms/RacePhoto'
import UploadPhoto from '@/components/Forms/UploadPhoto'
import RaceMedia from '@/components/Forms/RaceMedia'
import {pick} from 'ramda'
import moment from 'moment'
import SettingsService from "@/services/settings"
import TrainerService from '@/services/trainer'
import Selectize from '@/components/Selectize'
import TagService from '../../services/tag'
import RaceService from '../../services/races'
import { db} from '../../firebase'
export default {
  name: 'UpdateRace',
  data: () => ({
    update: null,
    upload: null,
    locales: [ {id: 'en', name: 'English'}, {id: 'ja', name: 'Japanese'}],
    types:[],
    channels:{},
    tagsOptions:[],
    selectedTags:[],
    trainerList:[],
    trainerId:'',
    raceTrainer:'',
    raceTypes:[],
    max_duration: 1440,
    max_rsvp_limit: 10000
  }),
  computed: mapGetters({
    trainer: 'Trainer/trainer',
    race: 'Race/race'
  }),
  methods: {
    initialize () {
      this.getRaceTypes().then(res => {
        if (res && res.data) {
          res.data.unshift('NONE')
          this.types = res.data
        }
      }).catch(error => {
        console.error('Error getting race types:', error)
      })

      this.getRace(this.$route.params.raceId)
      this.getAllTags()
      this.getTrainerList()
      this.getRaceTypeAvailable()
    },
    getRaceTypeAvailable(){
      RaceService.getRaceTypeAvailable().then(response => {
          if(response.data && response.data != undefined && response.data != ''){
            let allRaceTypes = response.data
            //Remove these from the second type (https://app.asana.com/0/1137425856170315/1200251895400268)
            let removeItem =["SOLO","PromoL","PromoI","PromoV","PromoE","PromoU","PromoR","NO_MEDAL","LIVE_60MIN","ON_DEMAND_MEDAL","ON_DEMAND_NO_MEDAL","WALK"]
            var removeElements = _.remove(allRaceTypes, obj => removeItem.includes(obj.name))
            // var addElements = allRaceTypes.push({englishText: 'PromoU', name: 'PromoU', japaneseText: 'PromoU'}, {englishText: 'PromoR', name: 'PromoR', japaneseText: 'PromoR'})
            this.raceTypes = allRaceTypes

            //this.raceTypes = response.data
          }
        }).catch(error => {
          console.log("Error getting race type--->>",error)
        })
    },
    getAllTags(){
      TagService.getAllTags().then((response)=>{
        console.log("response----",response)
        this.tagsOptions = response.data
        this.getRaceTags()
      })
    },
    getRaceTags(){
      TagService.getRaceTags(this.$route.params.raceId).then((response)=>{
        //console.log("this.options---",this.options.map(a => a.id))
        this.selectedTags = response.data.map(a => a.id)
      })
    },
    getTrainerList(){
      var that = this
      TrainerService.getAll().then(response => {
        if(response.data && response.data != undefined && response.data != ''){
          this.trainerList = response.data
        }
      }).catch(error => {
        console.log("Error get all trainer--->>",error)
      })
    },
    changeTrainer(){
      // CHANGE THE TRAINER OF SESSION
      TrainerService.getTrainer(this.trainerId).then(response => {
        this.raceTrainer = response.data
      }).catch(error => {
        console.log("Error Get trainer by id--->>",error)
      })
    },
    loadAudio(){
      document.getElementById("ondemand-audio").load()
    },
    handleSubmit(){
      this.$validator.validateAll()
        .then(success => {
          if (!success) {
            return
          }
          this.loadingUpdateButton()
          
          try {
            // Update Firebase data
            const firebaseUpdate = db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
              'streamingUrl': this.update.mobileChannelToPlay,
              'endSessionUrl': this.update.endSessionUrl
            }).catch(error => {
              console.error("Firebase error--", error)
            })
            
            // Set thirdtype null
            if(this.update.thirdType === ''){
              this.update.thirdType = null
            }
            
            // Update trainer
            this.update.trainer = this.raceTrainer // CHANGE THE TRAINER OF SESSION
            
            // Wait for Firebase update to complete before updating race
            Promise.resolve(firebaseUpdate).then(() => {
              // Make a copy of the update object to avoid mutation issues
              const raceData = JSON.parse(JSON.stringify(this.update))
            
              // Ensure the race ID is properly included
              if (!raceData.id) {
                console.error('Race ID is missing in update data')
                throw new Error('Race ID is required for update')
              }
            
              return this.updateRace(raceData)
            })
            .then(response => {
              this.$router.push({ path: '/admin/races' })
              this.error = ''
              this.resetUpdateButton()
            })
            .catch(error => {
              console.error('Failed to update race:', error)
              this.error = 'Failed!'
              this.resetUpdateButton()
            })
          } catch (error) {
            console.error('Error in handleSubmit:', error)
            this.error = 'An unexpected error occurred'
            this.resetUpdateButton()
          }
        })
    },
    ...mapActions({
      updateRace: 'Race/updateOne',
      getRace: 'Race/get',
      getRaceTypes:'Race/getTypes'
    }),
    loadingUpdateButton () {
      const btnUpdate = document.querySelector('#submit-form')
      btnUpdate.innerHTML = 'Updating...'
      btnUpdate.setAttribute('disabled', true)
    },
    resetUpdateButton () {
      const btnUpdate = document.querySelector('#submit-form')
      btnUpdate.innerHTML = 'Update Race'
      btnUpdate.removeAttribute('disabled', true)
    },
    getTimezone () {
      return new Date().toString().match(/([A-Z]+[+-][0-9]+.*)/)[1]
    },
    onDescriptionChange() {
        var key = window.event.keyCode

        // If the user has pressed enter
        if (key === 13) {
            document.getElementById("txtArea").value = document.getElementById("txtArea").value + "\n*"
            return false
        }
        else {
            return true
        }
    },
    async getExistingChannels(){
      const channels = await SettingsService.get()
      this.channels = channels.data
      //this.update.mobileChannelToPlay = channels.data.audioChannelA
      return channels.data
    },
    removeActionImg(){
      this.update.actionImageUrl = ''
    }
  },
  created () {
    this.initialize()
    this.getExistingChannels()
  },
  watch: {
    race () {
      console.log("this.race---",this.race)
      const race = pick(['id', 'name', 'description','mobileChannelToPlay', 'date', 'startDate', 'finishDate', 'type','secondType','thirdType', 'language', 'notes', 'imageUrl','audioFileUrl', 'schedule', 'trainer', 'duration','rsvp_limit','endSessionUrl','actionImageUrl'], this.race)
      console.log("race---",race)
      var stillUtc = moment.utc(race.date).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
      race.date = local
      console.log(race.endSessionUrl)
      if(race.endSessionUrl == undefined){ race.endSessionUrl = '' }
      this.update = race
      this.trainerId = race.trainer.id
      this.raceTrainer = race.trainer
      //set thirdtype null
      if(this.update.thirdType == null){
          this.update.thirdType = ''
      }
      // Clear any eager-validation errors that accumulated while fields
      // were mounted against empty values (before API data arrived).
      this.$nextTick(function() {
        this.$validator.reset()
      })
    }
  },
  components: {
    Container,
    RaceHeader,
    CustomForm,
    TextField,
    IntegerField,
    DateTimeField,
    RacePhoto,
    UploadPhoto,
    RaceMedia,
    Selectize
  }
}
</script>
<style>
.race-tags .selectize-control{
  width: 40%;
}
.race-tags .selectize-control.multi .selectize-input>div.active {
   background: #efefef;
    color: #000;
    border: 0 solid transparent;
}
.race-tags .selectize-control.multi .selectize-input>div{
  color: #000;
  margin: 0 10px 3px 0;
}
.actionImgContent{
  width: 40rem;
  margin-right: 10rem;
  /* margin-top: 50px; */
}
</style>



// WEBPACK FOOTER //
// Update.vue?80d0831e